import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--financial-disclosure-title'];
const INPUT_LABEL = content['household-info--financial-disclosure-label'];

const { discloseFinancialInformation } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    discloseFinancialInformation: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['discloseFinancialInformation'],
    properties: { discloseFinancialInformation },
  },
};
